

















































export let KeyCodes;(function (KeyCodes) {KeyCodes[KeyCodes["LEFT"] = 37] = "LEFT";KeyCodes[KeyCodes["UP"] = 38] = "UP";KeyCodes[KeyCodes["RIGHT"] = 39] = "RIGHT";KeyCodes[KeyCodes["DOWN"] = 40] = "DOWN";})(KeyCodes || (KeyCodes = {}));